
//-- auth popup --//

export const authConfig: any = {
    register: {
        id: 1,
        header: 'register'
    },
    register_otp: {
        id: 2,
        header: ''
    },
    login: {
        id: 3,
        header: 'log_in'
    },
    verify_email: {
        id: 4,
        header: 'verify_email'
    },
    password_otp: {
        id: 5,
        header: ''
    },
    password: {
        id: 6,
        header: 'forgot_password'
    }
}


//-- login component --//

export const loginFormDetails: any = [
    {
        name: "usr_email",
        type: "text",
        placeholder: "e_mail",
        label: "e_mail",
    },
    {
        name: "usr_password",
        type: "password",
        placeholder: "password",
        label: "password",
    },
];


//-- register component --//

export const registerConfig = () => {
    return [
        {
            name: "usr_fname",
            type: "text",
            placeholder: "first_name",
            label: "first_name",
            style: "col-6",
        },
        {
            name: "usr_lname",
            type: "text",
            placeholder: "last_name",
            label: "last_name",
            style: "col-6",
        },
        {
            name: "usr_phone",
            type: "number",
            placeholder: "number",
            label: "number",
            style: "col-6",
        },
        // {
        //     name: "cy_name",
        //     type: "text",
        //     placeholder: "company_name",
        //     label: `company_name`,
        //     style: `col-6 ${companyId ? 'd-none' : ''}`,
        // },
        
        {
            name: "usr_email",
            type: "text",
            placeholder: "e_mail",
            label: "e_mail",
            style: "col-12 ",
        },
        {
            name: "usr_password",
            type: "password",
            placeholder: "password",
            label: "password",
            style: "col-6",
        },
        {
            name: "confirmPassword",
            type: "password",
            placeholder: "re_enter_password",
            label: "re_enter_password",
            style: "col-6",
        },
    ];
};

//-- password component --//

export const passwordConfig = (selectedId:any,loginId:any) => {
    const visibleLogin = selectedId === loginId
    return [
      {
        name: "usr_email",
        type: "text",
        placeholder: "e_mail",
        label: "e_mail",
        style: ` ${!visibleLogin?'d-none':''}`,
      },

      {
        name: "usr_password",
        type: "password",
        placeholder: "new_password",
        label: "new_password",
        style: ` ${visibleLogin?'d-none':''}`,
      },
      {
        name: "confirm_password",
        type: "password",
        placeholder: "confirm_new_password",
        label: "confirm_new_password",
        style: ` ${visibleLogin?'d-none':''}`,
      },
    ];
  };